import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {Input} from "@angular/core";
import {Partecipant} from "../../../classes/common/partecipant";
import {ViewService} from "../../../services/common/view.service";


type Layout =
  "chip" |
  "item" |
  "itemBody";

type Status =
  "off" |
  "on";


@Component({
  selector: 'app-car',
  templateUrl: './car.component.html',
  styleUrls: ['./car.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarComponent implements OnInit {



  // component args

  @Input() car: Partecipant;
  // additional css classes
  @Input() css: string;

  @Input() layout: Layout = "item";



  // listener

  listener = {
    view: null,
  };



  constructor(
    private cd: ChangeDetectorRef,
    private view: ViewService,
  ) {}



  ngOnInit() {
    this.listenerView();
  }


  ngOnDestroy() {
    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }
  }




  // listener

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      // console.log("listener.view", obj);

      // this.zone.run(() => {

      this.view.pipeChanged++;
      this.cd.markForCheck();

      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);

      // });
    });
  }






}
